import { createContext } from 'react';
import type { Stripe } from '@stripe/stripe-js';

export interface StripeContextValue {
  stripePromise: Promise<Stripe | null>;
}

export const StripeContext = createContext<StripeContextValue | null>(null);
